var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 55C38.8071 55 50 43.8071 50 30C50 16.1929 38.8071 5 25 5C11.1929 5 0 16.1929 0 30C0 43.8071 11.1929 55 25 55Z",
    fill: "#007AB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9374 32.0111V42.3181H33.9617V32.7019C33.9617 30.2873 33.0989 28.6384 30.9353 28.6384C29.2842 28.6384 28.3033 29.7485 27.8701 30.8234C27.7128 31.2076 27.6723 31.741 27.6723 32.2798V42.3176H21.6961C21.6961 42.3176 21.7763 26.0309 21.6961 24.3451H27.6727V26.8919C27.6607 26.912 27.6438 26.9316 27.6331 26.9508H27.6727V26.8919C28.4669 25.67 29.8831 23.923 33.0584 23.923C36.9899 23.923 39.9374 26.4917 39.9374 32.0111ZM15.4446 15.6816C13.4004 15.6816 12.063 17.0235 12.063 18.7865C12.063 20.512 13.3616 21.8926 15.3661 21.8926H15.4049C17.4892 21.8926 18.7852 20.512 18.7852 18.7865C18.7455 17.0235 17.4892 15.6816 15.4446 15.6816ZM12.4182 42.3181H18.3921V24.3451H12.4182V42.3181Z",
    fill: "#F1F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.94f06851a9dbf4b32c9c9b27c0e7f0ed.svg";
export { ForwardRef as ReactComponent };